<template>
  <section class="landing-page">
    <Header />
    <Main />
    <HowItWorks />
    <FigmaPlugin />
    <Overview />
    <Pricing />
    <Testimonials />
    <BlogPosts />
    <SeoOverview />
    <ProductHunt />
    <Footer />

    <section class="hunt"></section>

    <footer class="footer"></footer>
  </section>
</template>

<script>
import Header from "@/components/landing/Header";
import Main from "@/components/landing/Main";
import HowItWorks from "@/components/landing/HowItWorks";
import FigmaPlugin from "@/components/landing/FigmaPlugin";
import Overview from "@/components/landing/Overview";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import BlogPosts from "@/components/landing/BlogPosts";
import ProductHunt from "@/components/landing/ProductHunt";
import SeoOverview from "@/components/landing/SeoOverview";
import Footer from "@/components/landing/Footer";

export default {
  components: {
    Header,
    Main,
    HowItWorks,
    FigmaPlugin,
    Overview,
    Pricing,
    Testimonials,
    BlogPosts,
    ProductHunt,
    SeoOverview,
    Footer,
  },
};
</script>
<style scoped>
* {
  color: #3d3d3d;
}

.landing-page {
  width: 100%;
  box-sizing: border-box;
}
</style>
